<template>
    <transition
        name="fade"
        mode="out-in"
    >
        <slot />
    </transition>
</template>

<script>
export default {
    name: 'RouterTransition',
};
</script>

<style lang="scss" scoped>
.fade-enter-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-leave-active {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
